import Marquee from "react-fast-marquee";
import { Overline, Reveal } from "./Reveal";

const LOGOS = [
  { src: "/logos/seal-california.png", name: "State of California", tall: true },
  { src: "/logos/seal-texas.png", name: "State of Texas", tall: true },
  { src: "/logos/kpmg.png", name: "KPMG" },
  { src: "/logos/indigo.png", name: "IndiGo" },
  { src: "/logos/radius.png", name: "Radius" },
  { src: "/logos/imz.png", name: "IMZ" },
  { src: "/logos/in10s.png", name: "In10s" },
  { src: "/logos/igt.png", name: "IGT" },
  { src: "/logos/partner-triangle.png", name: "Partner organisation", tall: true },
  { src: "/logos/partner-emblem.png", name: "Partner organisation", tall: true },
  { src: "/logos/partner-star.png", name: "Partner organisation", tall: true },
];

export default function LogoMarquee() {
  return (
    <section
      data-testid="allies-section"
      className="border-b border-white/10 py-20 lg:py-24"
    >
      <Reveal>
        <Overline className="text-center">Our clients</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <div data-testid="logo-marquee" className="mt-12 [mask-image:linear-gradient(90deg,transparent,black_12%,black_88%,transparent)]">
          <Marquee speed={26} gradient={false} pauseOnHover>
            {LOGOS.map((logo, i) => (
              <div key={`${logo.name}-${i}`} className="mx-10 flex items-center sm:mx-14">
                <img
                  src={logo.src}
                  alt={`${logo.name} logo`}
                  data-testid={`ally-logo-${i}`}
                  loading="lazy"
                  className={`w-auto opacity-60 transition-opacity duration-300 hover:opacity-100 ${
                    logo.tall ? "h-12 sm:h-14" : "h-7 sm:h-9"
                  }`}
                />
              </div>
            ))}
          </Marquee>
        </div>
      </Reveal>
    </section>
  );
}
